// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ep-z","slideIn":"Fp-z"};